<template>
  <div class="kr-layout-content">
    <!--个人基本资料-->
    <ul class="per-list">
      <li
        v-for="(item,index) in rout"
        :key="index"
        :class="{'active':n == index }"
        @click="trans(index,item.path)"
      >{{item.title}}</li>
    </ul>
    <div class="per-info">
      <router-view/>
    </div>
  </div>
</template>
<script>
export default {
  //   name: "App",
  data() {
    return {
      n: 0,
      rout: [
        {
          title: "基本资料",
          path: "/perData"
        },
        {
          title: "账号和密码",
          path: "/myAccount"
        },
        {
          title: "我的收藏",
          path: "/myCollect"
        },
        // {
        //   title: "我的消息",
        //   path: "/myMsg"
        // },
        {
          title: "我的关注",
          path: "/myCare"
        },
        // {
        //   title: "我的粉丝",
        //   path: "/myFans"
        // }
      ]
    };
  },
  methods: {
    trans(i, path) {
      this.n = i;
      this.$router.push(path);
    }
  },
  mounted() {
    this.$router.push("/perData");
  }
};
</script>
<style scoped>
</style>